module.exports = __webpack_public_path__ + "static/science-square.0d2bbd5e.jpg";